<template>
  <div class="container-fluid bg-white py-3">
    <div class="container">
      <div
        v-if="!current"
        class="row"
      >
        <div class="col-12">
          <div class="alert alert-info">
            You don't have any health data saved yet to generate your Scorecard.  Please <router-link :to="{name: 'health-data'}">
              Enter your health data
            </router-link> to see your results here.
          </div>
        </div>
      </div>
      <div
        v-if="current"
        class="row"
      >
        <div class="col-12 col-md-8 mb-4 mb-2">
          <notifications />
          <select
            v-if="healthdata.length"
            class="form-control"
            @change="setCurrent($event)"
          >
            <option
              v-for="(healthdataEntry, index) in healthdata"
              :key="index"
              :value="index"
            >
              {{ getDate(healthdataEntry.created_at) }}
            </option>
          </select>
        </div>
      </div>

      <div
        v-if="! isAuthenticated && healthdata.length"
        class="row"
      >
        <div
          class="alert alert-warning col-12 col-md-8"
        >
          Your health assessment is not saved.
          <router-link :to="{ name: 'signup' }">
            Create an account
          </router-link>
          to save your data.
        </div>
      </div>
    </div>
    <router-view />


    <HealthSources class="my-4" />
  </div>
</template>

<script>
import moment from 'moment';
import store from '../store.js';
import HealthSources from "../components/HealthSources.vue";

export default {
  components: {HealthSources},
  beforeRouteEnter(to,from,next){
    store.dispatch('healthData/GET_INITIAL_DATA').then(res => {
      next();
    }).catch(err => {
      next();
    })
  },
  computed: {
    healthdata() {
      return this.$store.state.healthData.all;
    },
    current() {
      return this.$store.getters['healthData/current']
    },
    isAuthenticated() {
      return this.$store.getters['user/authenticated'];
    },
  },
  methods: {
    getDate(dateString) {
      return moment.utc(dateString).local().format('MMMM Do YYYY h:mm a');
    },
    setCurrent($event) {
      this.$store.dispatch('healthData/SET_CURRENT', $event.target.value)
    }
  }
}
</script>
